// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-01-28 01:09:55 +0100 (Wed, 28 Jan 2026) $
//  Author    : Albert Charlier, Dirk Rothe, Tobias Schwarzkopf
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160104 $
//  Purpose   : definition lists
// =============================================================================
// --- Framework imports
import log from 'uix/logging';
import { dict } from 'ldash';
// load from server/config
import languageCodes from '../../../config/codes.json';
// --- Globals
// index on first access
let CODE_MAP = null;
export const translateLangCode = (code, targeti18n)=>{
    if (!CODE_MAP) {
        CODE_MAP = dict(languageCodes.codes.code.map((e)=>[
                e.$['iso639-2'],
                {
                    de: e.de,
                    en: e.en,
                    fr: e.fr,
                    it: e.it
                }
            ]));
    }
    let res = CODE_MAP[code];
    if (!res) {
        return code;
    }
    res = res[targeti18n];
    if (!res) {
        return code + ' ' + targeti18n;
    }
    return res;
};
